/**
 * Determines the appropriate contrast color for text/icons based on background color.
 * Uses the YIQ formula for calculating relative luminance.
 *
 * @param hex - The hex color value (with or without #)
 * @returns 'rgba(0, 0, 0, 0.75)' for light backgrounds, 'rgba(255, 255, 255, 0.75)' for dark backgrounds
 */
export const getContrastColor = (hex: string): string => {
  // Remove hash if present
  const cleanHex = hex.replace('#', '');

  // Convert 3-digit hex to 6-digit
  const fullHex =
    cleanHex.length === 3
      ? cleanHex[0] + cleanHex[0] + cleanHex[1] + cleanHex[1] + cleanHex[2] + cleanHex[2]
      : cleanHex;

  // Parse RGB values
  const r = parseInt(fullHex.substring(0, 2), 16);
  const g = parseInt(fullHex.substring(2, 4), 16);
  const b = parseInt(fullHex.substring(4, 6), 16);

  // Calculate YIQ (relative luminance)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Return white for dark backgrounds, black for light backgrounds
  return yiq >= 128 ? 'rgba(0, 0, 0, 0.75)' : 'rgba(255, 255, 255, 0.75)';
};
